import React, { useState, useEffect, useRef } from 'react';
import './header.css';
import logoIcon from '../../assets/img/logo/logo.png';
import { FaHome, FaPhone, FaClipboardList, FaInfoCircle, FaBriefcase } from 'react-icons/fa';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const mobileTabRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768); 
    };

    handleResize(); 
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileTabRef.current && !mobileTabRef.current.contains(event.target)) {
        setActiveTab(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName === activeTab ? null : tabName);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`} role="banner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-2">
            <div className="header__logo">
              <Link to="/" className="logo-link">
                <img src={logoIcon} alt="Icon" className="logo-icon" />
              </Link>
            </div>
          </div>
          <div className="col-lg-8">
            {!isMobileView && (
              <nav className="header__nav__menu desktop-menu" role="navigation">
                <ul>
                  <li className="active"><Link to="/">Home</Link></li>
                  <li><Link to="/bookingpage">Book A Call</Link></li>
                  <li><Link to="/testimonials">Testimonials</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                </ul>
              </nav>
            )}
          </div>
          <div className="col-lg-2">
            <div className="social-icons" role="presentation">
              <a href="https://wa.me/+923095921582" aria-label="WhatsApp"><FaWhatsapp className="social-icon" /></a>
              <a href="https://www.instagram.com/shanzaeziaphotography/" aria-label="Instagram"><FaInstagram className="social-icon" /></a>
            </div>
          </div>
        </div>
      </div>

      {isMobileView && (
  <nav className="mobile-tab-bar" role="navigation" ref={mobileTabRef}>
    <ul>
      <li>
        <Link to="/" className={`icon-link ${activeTab === 'Home' ? 'active' : ''}`} onClick={() => handleTabClick('Home')}>
          <FaHome />
          <span>Home</span>
        </Link>
      </li>
      <li>
        <Link to="/bookingpage" className={`icon-link ${activeTab === 'About' ? 'active' : ''}`} onClick={() => handleTabClick('About')}>
          <FaPhone />
          <span>Book A Call</span>
        </Link>
      </li>
      <li>
        <Link to="/testimonials" className={`icon-link ${activeTab === 'Projects' ? 'active' : ''}`} onClick={() => handleTabClick('Projects')}>
          <FaClipboardList />
          <span>Testimonials</span>
        </Link>
      </li>
      <li>
        <Link to="/about" className={`icon-link ${activeTab === 'Tech' ? 'active' : ''}`} onClick={() => handleTabClick('Tech')}>
          <FaInfoCircle />
          <span>About Us</span>
        </Link>
      </li>

    </ul>
  </nav>
)}

    </header>
  );
};

export default Header;